import $ from 'jquery';
import 'select2';

export default function initSelect2(el) {
    const multiExtra = $(el).parent().find('.multiple-choice-extra');
    const elSelect = $(el).find('select');
    elSelect.select2({
        dropdownParent: $(el).closest('.multiselect'),
        closeOnSelect: false,
        width: 'resolve',
    });
    // .on('change.select2', () => {
    //     // Revalidate the color field when an option is chosen
    //     fv.revalidateField(elSelect);
    // });
    elSelect.on('select2:opening select2:closing', () => {
        const $searchIn = $(el).parent().find('.select2-search__field');
        $searchIn.prop('disabled', true);
    });
    elSelect.on('select2:open', () => {
        if (!elSelect.children('.multiple-choice-extra').length) {
            $(el).parent().find('.select2-dropdown').append(multiExtra);
        }
    });
    elSelect.on('change', () => {
        // refresh dropdown position
        $('html,body').trigger('scroll');
    });
    $(el).parent().find('.multiple-choice-all').on('click', () => {
        const all = $.map(elSelect.find('option'), (option) => option.value);
        elSelect.val(all).trigger('change').select2('close');
    });
    $(el).parent().find('.multiple-choice-apply').on('click', () => {
        elSelect.select2('close');
    });
    $(el).parent().find('.multiple-choice-cancel-in').on('click', () => {
        // unselect all, refresh labels, refresh checkboxes
        elSelect.val(null).trigger('change').select2('close');
    });
    elSelect.on('select2:unselect', () => {
        elSelect.select2('open');
    });
}
